import sectionsRef from "@models/interactions/sections-ref";
import LegalLayout from "@components/templates/legal-layout";

export default function MonetizationTerms() {
  const { model, operations } = sectionsRef(15);

  return (
    <LegalLayout>
      <main className="w-full flex flex-col text-white px-4 max-w-[900px] mt-[60px] pb-5">
        <h2 className="text-4xl text-center font-semibold">CONTENT MONETIZATION TERMS AND CONDITIONS</h2>
        <span className="text-left text-sm mt-4 leading-[23px]">PLEASE READ THE FOLLOWING TERMS AND CONDITIONS AGREEMENT (“<strong>CONTENT MONETIZATION TERMS</strong>”)
          CAREFULLY. BY USING OR PARTICIPATING IN OUR CONTENT MONETIZATION PROGRAM OR FEATURES 
          (“<strong>CONTENT MONETIZATION</strong>”), YOU HEREBY ACCEPT AND AGREE TO BE LEGALLY BOUND BY THESE TERMS 
          AND ALL TERMS INCORPORATED HEREIN BY REFERENCE. IT IS YOUR RESPONSIBILITY TO READ THE TERMS
          BEFORE PROCEEDING TO PARTICIPATE IN OUR CONTENT MONETIZATION PROGRAM, INCLUDING BUT NOT 
          LIMITED TO ALL FEATURES, SITES, SERVICES, AND CONTENT.</span>
        <div className="flex flex-col text-white text-xl mt-4">
          <span>
            1.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[0]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              ACCEPTANCE OF TERMS
            </a>
          </span>
          <span>
            2.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[1]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              ELIGIBILITY
            </a>
          </span>
          <span>
            3.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[2]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              CONTENT MONETIZATION
            </a>
          </span>
          <span>
            4.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[3]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              PAYMENT
            </a>
          </span>
          <span>
            5.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[4]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              INTELLECTUAL PROPERTY
            </a>
          </span>
          <span>
            6.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[5]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              PARTIES’ RELATIONSHIP
            </a>
          </span>
          <span>
            7.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[6]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              COMMUNICATIONS
            </a>
          </span>
          <span>
            8.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[7]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              CONFIDENTIALITY
            </a>
          </span>
          <span>
            9.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[8]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              REPRESENTATIONS AND WARRANTIES
            </a>
          </span>
          <span>
            10.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[9]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              ACCOUNT SUSPENSION/TERMINATION; FORFEITURE; WITHDRAWAL
            </a>
          </span>
          <span>
            11.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[10]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              DISCLAIMER
            </a>
          </span>
          <span>
            12.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[11]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              LIMITATION OF LIABILITY
            </a>
          </span>
          <span>
            13.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[12]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              ASSIGNMENT
            </a>
          </span>
          <span>
            14.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[13]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              GENERAL
            </a>
          </span>
        </div>

        <article className="flex w-full flex-col justify-start gap-[18px] lg:w-[916px] text-white mt-4">
          <section ref={model.refs[0]} className="flex flex-col gap-5 ">
          <span className="flex flex-col gap-[18px]">
            <strong className="text-xl">1. ACCEPTANCE OF TERMS</strong>
            <p className="ml-12">The following Content Monetization Terms govern Your participation 
              in the Content Monetization program or features on the Memo’d Platform. 
              The Content Monetization Terms are subject to, and will also include, the Memo’d 
              Terms of Service, Privacy Policy, Tipping Policy, and all other Memo’d policies and 
                guidelines, each as may be updated or amended from time to time (together, the “<strong>Policies</strong>”).
              In the case of any inconsistency between these Content Monetization Terms and the Policies,
              insofar as they relate to the Content Monetization program or features on the Memo’d Platform,
              these Content Monetization Terms will prevail. Upon expiration or termination of Content 
              Monetization or Creator’s participation in the Content Monetization program or features, 
              the Policies will remain in effect and continue to apply to Your use of the Platform. Any 
              capitalized terms used but not defined herein has the respective meanings given to them in the 
              Policies.
            </p>
            </span>
          </section>
          <section ref={model.refs[1]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">2. ELIGIBILITY</strong>
              <p className="ml-12">
                <strong>2.1 Memo’d Account.</strong> You must have an active Memo’d account in good standing and in
                 compliance with Memo’d’s Policies.
              </p>
              <p className="ml-12"><strong>2.2 Age Requirements.</strong> By participating in Content Monetization, you agree to be bound
                 by these Terms as a legal agreement. You must be at least 13 years old to participate
                  in Content Monetization.
              </p>
              <p className="ml-12">
                <strong>2.3 Permission.</strong> If You are under 18 years old, You represent that You have Your parent or guardian’s
                permission to participate in Content Monetization. Please have them read these Content Monetization
                Terms with You. If You are a parent or guardian of a Creator under the age of 18, by allowing your
                child to participate in Content Monetization, you are subject to these Content Monetization Terms and 
                responsible for your child’s activity on the Platform.
              </p>
              <p className="ml-12">
                <strong>2.4 Businesses.</strong> If You are using Content Monetization on behalf of a company or
                organization, You represent that You have the authority to act on behalf of that
                entity, and that such entity accepts these Content Monetization Terms.
              </p>
              <p className="ml-12">
              <strong>2.5 Payment Setup.</strong> You must provide at least one valid linked digital payment
                account that can be used as a payment method through the Content Monetization
                features, and complete all necessary onboarding documentation 
                (including, without limitation, any tax reporting documents required by Memo'd or the payment
                account provider).
              </p>
            </span>
          </section>
          <section ref={model.refs[2]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">3. CONTENT MONETIZATION</strong>
              <p className="ml-12">
                <strong>3.1  Tipping.</strong> Tipping is a feature that allows Users to compliment Creators monetarily
                for their Content (<strong>“Tipping”</strong>) and Creators to earn monetary gratitude from Users for 
                their Content. Users and Creators engage with Tipping voluntarily and are under no 
                obligation to send or accept tips.
              </p>
              <p className="ml-12">
                <strong>3.2 Locked Content.</strong> Locking is a feature that grants Members access to Content
                for a determined one time or recurring fee (“<strong>Locked Content</strong>”) and Creators the
                ability to generate revenue from their Content. Users and Creators engage with
                Locked Content voluntarily and are under no obligation to pay for or offer Locked
                Content.
             </p>
              <p className="ml-12">
                <strong>3.3  Availability. By participating in Content Monetization, You understand 
                that availability to Content may vary in duration or accessibility. Neither Creator
                nor Memo’d makes any guarantees as to the long-term availability of such Content
                on Memo’d Platforms. Creator and Memo’d will take reasonable steps to ensure Members
                who have paid for Content have reasonable access to the Content for a reasonable time.
                Memo’d reserves the right in its sole discretion to modify, terminate, establish, 
                control, and limit any aspect of Content Monetization from time to time,
                and without any other notice to You. Any such change, update,
                or modification will be effective immediately upon posting. Please review these
                Content Monetization Terms periodically to ensure that you continue to agree with
                all of the terms.</strong> If You continue to participate in Content Monetization after 
                those changes, updates, or modifications are in effect, You agree to the revised
                terms.
             </p>
           </span>
          </section>
          <section ref={model.refs[3]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">4. PAYMENT</strong>
              <p className="ml-12">
                4.1  Tipping Revenue. Creators may keep 100% of the donations/tips from Users 
                (less any applicable fees described herein).
              </p>

              <p className="ml-12">
                <strong>4.2  Locked Content Revenue.</strong> Memo’d applies a revenue share model to Locked Content 
                (<strong>“Locked Content Revenue Share”</strong>). Memo’d is paid a 10% share of the monthly net income 
                You earn through Your Locked Content (after any applicable Payment Processor fees,
                In-App Purchase fees, Additional Fees, or Taxes enumerated below).
              </p>

              <p className="ml-12">
                <strong>4.3  Payment Provider Integrations for Tipping.</strong> Memo’d integrates with third-party 
                payment service providers (each, a “<strong>Payment Provider</strong>”) such as Patreon, PayPal,
                and Buy Me a Coffee for Tipping. The applicable Payment Provider is responsible
                for all aspects of the processing of the Tipping transaction on behalf of the Creator.
                We are not responsible for the processing of the payment nor for any payment services
                provided to You by any Payment Provider, including the availability of the Payment
                Provider’s services. If You have any questions or issues in relation to the services
                provided to You by a Payment Provider, please contact the applicable Payment Provider.
              </p>

              <p className="ml-12">
                <strong>4.4  Payment Processor Fees for Locked Content.</strong> Memo’d uses one or more third-party payment
                processors (each, a “<strong>Payment Processor</strong>”), such as Stripe and PayPal, to collect, process,
                and remit payments on Memo’d’s behalf for Locked Content.</p>
              <p className="ml-12">
                All income earned from User purchases made through a website or a system browser are subject
                to Payment Processor fees deducted off the top. Such fees are mandated and managed by the Payment
                Processor, subject to change, and no portion of it is kept by Memo’d. In addition, You may be subject
                to the terms, conditions, privacy policies, processing procedures, and personal information collection practices 
                of the Payment Processor, in addition to these Content Monetization Terms.</p>

              <p className="ml-12">
                <strong>4.5  In-App Purchase Fees for Locked Content.</strong> All income earned from User purchases made through the iOS
                application are subject to Apple Inc.’s commission fee deducted off the top. This fee is mandated and managed
                by Apple, subject to change, and no portion of it is kept by Memo’d. For the most up-to-date Apple commission rate,
                please email <a href="mailto:support@memod.com" className=" text-blue-700 hover:underline">support@memod.com </a>.
              </p>

              <p className="ml-12">
              <strong>4.6  Additional Fees.</strong> You are responsible for any fees, taxes, duties, or charges incurred
               through services provided to You by Your Payment Provider or Payment Processor.
              </p>

              <p className="ml-12">
                <strong>4.7  Taxes on Platform Earnings.</strong> You may be liable to pay taxes to Your country of residence
                 on Your Platform earnings from Content Monetization. Check with Your local tax authorities 
                 for detailed guidance. Memo’d will collect tax identification information and will charge 
                 and withhold the applicable taxes if required by law. Notwithstanding the foregoing, You will 
                 be solely responsible for bearing, reporting, and remitting all income or withholding taxes and 
                 other government charges which may be due as a result of the payments received.
              </p>

              <p className="ml-12">
                <strong>4.8  Refunds.</strong> You recognize and agree that You shall not have any Refund rights for Tipping or
                Locked Content.
              </p>

              </span>
          </section>
          <section ref={model.refs[4]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">5. INTELLECTUAL PROPERTY</strong>
              <p className="ml-12">
                <strong>5.1  Memo’d Intellectual Property.</strong> The Creator will be the sole and exclusive owner
                of all intellectual property rights in any Memo that the Creator writes.
                You understand and agree that Memo’d may from time to time use Your Content
                in a manner in accordance with the Terms of Service. Members who engage with Content
                Monetization,tip, and/or pay any fees to access Locked Content do not have any
                intellectual property rights in any Content.
              </p>

              <p className="ml-12">
                <strong>5.2  License Grant.</strong> Memo’d hereby grants to You a non-exclusive, limited license during
                the term of this Agreement, under all intellectual property rights owned or controlled
                by Memo’d, solely to the extent required for You to participate in Content Monetization
                in accordance with these Content Monetization Terms. With the exception of the foregoing
                limited license, no right, title or interest in or to any intellectual property rights
                of Memo’d are granted to You.
              </p>

              
              <p className="ml-12">
                <strong>5.3  Release; Right of Publicity.</strong> You grant to Memo’d the right to use Your name, voice,
                image, likeness, and biographical information You provide to Memo’d (collectively,
                “<strong>Attributes</strong>”) in connection with the distribution, exhibition, marketing, and other use of
                Your Locked Content. You release Memo’d, its affiliates, and their respective assigns,
                licensees, and successors from any claims that may arise regarding the use of Your Attributes,
                including any claims of defamation, invasion of privacy, or infringement of moral rights,
                rights of publicity, or copyright.
              </p>
            </span>
          </section>
          <section ref={model.refs[5]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">6. PARTIES’ RELATIONSHIP</strong>
              <p className="ml-12">
                 Your participation in Content Monetization does not imply any agency,
                 representation, sponsorship, or endorsement between Memo’d and You.
                 Your participation in Content Monetization is voluntary and at will.
                 Nothing in Your participation in Content Monetization or this Agreement
                 should be construed to create a partnership, joint venture, or employer-employee
                 relationship.
              </p>

            </span>
          </section>
          <section ref={model.refs[6]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">7. COMMUNICATIONS</strong>
              <p className="ml-12">
                Subject to the Privacy Policy, you may receive promotional email communications regarding the Services 
                from Memo’d from time to time. If You would like to unsubscribe from these promotional emails, find and 
                click the unsubscribe button at the bottom of the promotional emails.</p>
            </span>
          </section>
          <section ref={model.refs[7]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">8. CONFIDENTIALITY</strong>
              <p className="ml-12">
                Any information about Memo’d, its affiliates, or its products, including the Platform and the Services,
                that is made available to You through the Services, including but not limited to this Agreement,
                that is not otherwise publicly available is Memo’d’s confidential information
                (“<strong>Confidential Information</strong>”). You agree not to disclose any Confidential
                Information to any third party under any circumstance, unless previously approved in writing by Memod.</p>
            </span>
           
          </section>
          <section ref={model.refs[8]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">9. REPRESENTATIONS AND WARRANTIES</strong>
                <p className="ml-12">You are solely responsible for your Posted Content and the consequences of posting it.
                  You should only provide Content that you are comfortable sharing with others. By posting
                  Your Posted Content, You represent, and warrant that:
                </p>
                <p className="ml-12">9.1  Your Posted Content does not and will not (i) infringe, violate, or misappropriate any
                  third-party’s and/or intellectual property, privacy, or proprietary right, (ii) defame, harass,
                  bully, or impersonate any other person, or (iii) violate any other law, rule, or regulation;
                </p>
                <p className="ml-12">9.2  You have, or have obtained, all rights, licenses, consents, permissions, power and/or
                  authority necessary to grant the rights granted herein for any Posted Content that You submit,
                  post, or display on or through the Services;
                </p>
                <p className="ml-12">9.3  Your Posted Content does not contain material subject to copyright or other proprietary
                  rights, unless You have necessary permission or are otherwise legally entitled to post the
                  material and to grant Memo’d the license described herein;
                </p>
                <p className="ml-12">
                  9.4  Your Posted Content does not violate these Terms or Memo’d’s Terms of Service, including
                  those additional terms and policies incorporated by reference; and
                </p>
                <p className="ml-12">
                  9.5  Unless You have received prior written authorization, your Posted Content specifically
                  does not contain any pre-release or non-public beta feature or content or any Confidential
                  Information of Memo’d or confidential information of third parties.
                </p>
            </span>
           
          
          </section>
          <section ref={model.refs[9]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">10. ACCOUNT SUSPENSION/TERMINATION; FORFEITURE; WITHDRAWAL</strong>
              <p className="ml-12">
              <strong>10.1  Account Suspension or Termination.</strong> We may suspend or terminate Your account or cease
               providing You with all or part of the Services at any time for any or no reason, including,
               but not limited to, if we reasonably believe: (i) You have violated these Terms or the
               Terms of Service; (ii) You create risk or possible legal exposure for us; (iii)
               Your account should be removed due to unlawful conduct; (iv) Your account should be 
               removed due to prolonged inactivity; or (v) our provision of the Services to You is no
               longer commercially viable. We will make reasonable efforts to notify You by the email
               address associated with Your account or the next time You attempt to access Your account,
               depending on the circumstances.
              </p>
              <p className="ml-12">
              <strong>10.2  Forfeiture.</strong> Without limiting Our other rights or remedies, if We believe You have
               violated these Terms or the Terms of Service, We may determine that all or any portion
               of the remaining platform earnings balance in Your account that You may otherwise have
               been entitled to receive will be void and forfeited.
              </p>
              <p className="ml-12">
                <strong>10.3  Withdrawal.</strong> You may withdraw Your participation in Content Monetization
                by disabling the Content Monetization features and/or providing Memo’d with written notice of
                Your Intent to Withdraw. An electronic communication or e-mail (“Electronic Notice”) shall be
                deemed written notice for purposes of this Section 11.3 if sent to <a href="mailto:support@memod.com" className="hover:underline text-blue-700">support@memod.com</a>.
              </p>
           </span>
          </section>
          <section ref={model.refs[10]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">11. DISCLAIMER</strong>
              <p className="ml-12">Your access to and use of the Services or any Posted Content are at Your own risk.
               You understand and agree that the Services are provided to you on an “AS IS” and “AS AVAILABLE”
               basis. The “Memo’d Entities” refers to Memo’d, its related companies, affiliates, officers,
               directors, employees, agents, representatives, partners, and licensors. Without limiting the foregoing,
               to the maximum extent permitted under applicable law, THE MEMO’D ENTITIES DISCLAIM ALL WARRANTIES AND CONDITIONS,
               WHETHER EXPRESS OR IMPLIED, OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
               The Memo’d Entities make no warranty or representation and disclaim all responsibility and liability for:
               (i) the completeness, accuracy, availability, timeliness, security or reliability of the Services or any Posted
               Content; (ii) any harm to Your computer system, loss of data, or other harm that results from access to or use of
               the Services or any Posted Content; (iii) the deletion of, or the failure to store or to transmit, any Posted Content
               and other communications maintained by the Services; and (iv) whether the Services will meet Your requirements or be
               available on an uninterrupted, secure, or error-free basis. No advice or information, whether oral or written, obtained
               from the Memo’d Entities or through the Services, will create any warranty or representation not expressly made herein.
              </p>
            </span>  
          </section>
          <section ref={model.refs[11]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">12. LIMITATION OF LIABILITY</strong>
              <p className="ml-12">TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE MEMO’D ENTITIES SHALL NOT BE LIABLE
                FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR ANY LOSS OF 
                PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL,
                OR OTHER INTANGIBLE LOSSES, RESULTING FROM (i) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS
                OR USE THE SERVICES; (ii) ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE SERVICES,
                INCLUDING WITHOUT LIMITATION, ANY DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OF OTHER USERS
                OR THIRD PARTIES; (iii) ANY CONTENT OBTAINED FROM THE SERVICES; OR (iv) UNAUTHORIZED ACCESS,
                USE OR ALTERATION OF YOUR TRANSMISSIONS OR CONTENT. IN NO EVENT SHALL THE AGGREGATE LIABILITY
                OF THE MEMO’D ENTITIES EXCEED THE GREATER OF ONE HUNDRED U.S. DOLLARS (U.S. $100.00)
                OR THE AMOUNT YOU PAID MEMO’D, IF ANY, IN THE PAST SIX MONTHS FOR THE SERVICES GIVING RISE
                TO THE CLAIM. THE LIMITATIONS OF THIS SECTION SHALL APPLY TO ANY THEORY OF LIABILITY,
                WHETHER BASED ON WARRANTY, CONTRACT, STATUTE, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE,
                AND WHETHER OR NOT THE MEMO’D ENTITIES HAVE BEEN INFORMED OF THE POSSIBILITY OF ANY SUCH
                DAMAGE, AND EVEN IF A REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL
                PURPOSE.
              </p>
            </span>
          </section>
          <section ref={model.refs[12]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">13. ASSIGNMENT</strong>
              <p className="ml-12">Creator will not assign, sell, transfer, delegate or otherwise dispose of,
                whether voluntarily or involuntarily, by operation of law or otherwise, this 
                Agreement or any or its rights or obligations under this Agreement without 
                Memo’d’s prior written consent. Memo’d may freely assign this Agreement or any 
                of its rights or obligations under this Agreement without the consent of the 
                Creator.
              </p>
            </span>
          </section>
          <section ref={model.refs[13]} className="flex flex-col gap-5">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">14. GENERAL</strong>
                <p className="ml-12"><strong>14.1  Applicable Law</strong>. Any and all disputes and causes of action arising out of or connected with
                  Content Monetization and the enforceability of these Terms, shall be governed by and construed in
                  accordance with the laws of the state of California without regard to its conflict of law
                  provisions. To the extent that any lawsuit is permitted under this Agreement, You and Memo’d
                  hereby expressly consent to the personal and exclusive jurisdiction and venue of the state and
                  federal courts located in the City and County of San Francisco, California, and waive any
                  objection as to inconvenient forum.
                </p>
 
                <p className="ml-12"><strong>14.2  Entire Agreement.</strong> These, including the Terms of Service, Privacy Policy and any other terms
                  and conditions which are incorporated herein or might accompany Content Monetization or applicable
                  Service, constitute the entire agreement between You and Memo’d and shall govern the use of Content
                  Monetization, superseding any prior agreement between You and Memo’d with respect to Content
                  Monetization. You may also be subject to additional terms and conditions that may apply when
                  You use or purchase certain other Memo’d Services, affiliate Services, third-party content,
                  or third-party software.
                </p>
 
                <p className="ml-12"><strong>14.3  Waiver; Severability.</strong> At any time, should Memo’d fail to exercise or enforce any right of
                  provision of these Terms, such failure shall not constitute a waiver of such right or provision.
                  If any provision of these Terms is found by a court of competent jurisdiction to be invalid,
                  the parties nevertheless agree that the court should endeavor to give effect to the parties’
                  intentions as reflected in the provision, and the other provisions of the Terms remain in
                  full force and effect.
                </p>
 
                <p className="ml-12"><strong>14.4  No Right of Survivorship; Non-Transferability.</strong> You acknowledge and agree that Your account is
                  non-transferable and any rights to Your account, earnings, and/or contents within Your account shall
                  terminate upon Your death.
                </p>
 
                <p className="ml-12"><strong>14.5  Changes to Content Monetization Terms.</strong> Memo’d is constantly changing and improving the Services.
                  Memo’d may, from time to time, need to make changes to the terms and conditions or policies, in order
                  to reflect changes that may also apply to your use of the Services - including the Content Monetization Terms,
                  the Terms of Service, our Policies, and other contractual documents. . Such revisions shall be effective immediately.
                  Your continued participation in Content Monetization indicates Your acceptance of such changes,
                  and as such, Your frequent review of this Agreement and policies currently in effect.
                  Should You not agree to any updated, revised or modified terms, You must stop using
                  the provided Services forthwith.
                </p>
 
                <p className="ml-12"><strong>14.6  Assignment.</strong> We may assign our agreement with You to any affiliated company or to any entity 
                  that succeeds to all or substantially all of our business or assets related to the Services.
                  Neither these Terms nor any right, obligation, or remedy hereunder is assignable, transferable,
                  delegatable, or sublicensable by You except with our prior written consent, and any attempted
                  assignment, transfer, delegation, or sublicense shall be null and void.
                </p>
 
                <p className="ml-12">
                <strong>14.7  Electronic Communications.</strong> When You use the Services, or send e-mails, text messages,
                  and other communications from Your computer or mobile device to us, You may be communicating
                  with us electronically. You consent to receive communications from Memo’d electronically,
                  such as e-mails, texts, mobile push notices, or notices, and messages through the Services,
                  and you can retain copies of these communications for your records. You agree that all agreements,
                  notices, disclosures, and other communications that we provide to You electronically satisfy any
                  legal requirement that such communications be in writing.
                </p>
                <p>Last updated: May 2023</p>

            </span>
          </section>
        </article>

      </main>
    </LegalLayout>
  );
}
